import { mapActions, mapGetters, mapState } from "vuex";

export const baseSpeedFooter = {
  data() {
    return {
      isModalOpen: false
    }
  },
  computed: {
    ...mapState(['items', 'hasAuth', 'bids', 'temporaryBidItemsIsLoading']),
    ...mapGetters(['getItem']),

    itemLabel() {
      const itemCount = this.speedBidItems?.length;
      return `${itemCount} ${itemCount > 1 ? 'Bids' : 'Bid'} Pending`;
    },
    showFooter() {
      return !this.temporaryBidItemsIsLoading && this.speedBidItems?.length > 0;
    },
  },
  watch: {
    showFooter(showFooter) {
      this.SET_STATE([{ stateName: 'isShowingSpeedBiddingFooter', data: showFooter, isJson: false }])
    }
  },
  methods: {
    ...mapActions(['SET_STATE']),
    showReviewModal() {
      this.isModalOpen = true;
    }  ,
    hideReviewModal() {
      this.isModalOpen = false;
    },
  },
};